<template>
  <div>
    <v-card class="mx-auto" width="256" tile>
      <v-navigation-drawer permanent>
        <div class="text-center" style="padding-top: 20px;">
          <v-chip class="ma-2" color="deep-purple darken-1" text-color="white">
            <v-avatar left>
              <v-icon small>mdi-office-building-marker-outline</v-icon>
            </v-avatar>
            <strong>hObject</strong> Elements
          </v-chip>
        </div>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group v-model="itemHObject" color="deep-purple accent-2">
            <v-virtual-scroll
              :bench="benchedHObjects"
              :items="hObjects"
              height="300"
              item-height="40"
              class="dark"
            >
              <template v-slot="{ item }">
                <HObjectComponent :hObject="item" />
              </template>
            </v-virtual-scroll>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-card>
    <br />
    <WidgetsComponent
      v-for="(hObject, iWidget) in hObjects"
      :key="iWidget"
      :widgets="hObject.widgets ? hObject.widgets : []"
      :benchedWidgets="hObject.widgets ? hObject.widgets.length : 0"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

import HObjectComponent from '@/components/HObject/HObject'
import WidgetsComponent from '@/components/Widget/Index'

export default {
  name: 'hObjectsComponent',
  components: {
    HObjectComponent,
    WidgetsComponent
  },
  data() {
    return {
      itemHObject: null
    }
  },
  props: {
    hObjects: {
      required: true,
      type: Array,
      default: []
    },
    benchedHObjects: {
      required: true,
      type: Number,
      default: 0
    }
  },
  mounted: function() {},
  methods: {}
}
</script>

<style scoped>
.v-card {
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0.0) !important;
}

.dark {
  scrollbar-width: thin;
  scrollbar-color: #3e3e3e #202020;
}

.dark::-webkit-scrollbar {
  width: 15px;
}

.dark::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.dark::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.dark::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/HObject/Index.vue